import { useContext } from "react";
import { UserContext } from "store/UserContextPovider";
// import UserContextPovider from "store/UserContextPovider";

const useUser = () => useContext(UserContext);

export default useUser;
